/**
 * @module Page-IT-Consultancy
 */

import { BANNER_TYPE } from "../../../globals/constants";
import { useEffect } from "react";
import { loadScript } from "../../../globals/common-functions";
import banner from "../../../globals/banner.json";
import AvertImage from "../../../globals/elements/avertimg";
import SectionInnerPageBanner from "../../sections/common/banner";

function ITConsultancyPage() {

    useEffect(()=>{
        loadScript("js/custom.js");
    })

    return (

        <div className="av-sv2-wrap">
            <SectionInnerPageBanner _data={banner.service_detail} _type={BANNER_TYPE.COMPACT} />

            {/* Hero */}
            <div className="section-full p-t120 p-b0 site-bg-white">
                <div className="container">
                    <div className="av-hero-v2">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="av-hero-eyebrow">
                                    <i className="feather feather-compass"></i>
                                    Expert Guidance
                                </div>
                                <h1>IT Consultancy & Strategy</h1>
                                <p className="av-hero-lead">
                                    Technology decisions shouldn't keep you up at night. We sit down with you, understand
                                    what your business actually needs, and help you make choices you'll feel good about —
                                    not just today, but years from now.
                                </p>
                            </div>
                            <div className="col-lg-5">
                                <div className="av-hero-visual">
                                    <AvertImage src="images/services/it-consultancy.jpg" alt="IT Consultancy & Strategy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* What We Help With */}
            <div className="av-section-v2 av-bg-slate">
                <div className="container">
                    <div className="av-sh">
                        <div className="av-sh-label">What We Do</div>
                        <h2>Making Technology Work for You</h2>
                        <p>With so many vendors and tools out there, it's hard to know what's actually worth your time and money. We help you cut through the noise.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-map"></i>
                                </div>
                                <h3>Technology Strategy</h3>
                                <p>We look at where your business is headed and map out a technology plan that gets you there — without the unnecessary complexity or overspending.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-search"></i>
                                </div>
                                <h3>Software Evaluation</h3>
                                <p>Not sure which tools to use? We test, compare, and recommend software based on how well it fits your workflows — not who has the best marketing.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-shield"></i>
                                </div>
                                <h3>Security & Risk Reviews</h3>
                                <p>We check your setup for vulnerabilities and give you honest, practical recommendations to protect your data and your customers.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Process */}
            <div className="av-section-v2">
                <div className="container">
                    <div className="av-sh">
                        <div className="av-sh-label">Our Process</div>
                        <h2>How We Work Together</h2>
                    </div>

                    <div className="row av-timeline">
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">1</div>
                                <h4>Listen</h4>
                                <p>We start with honest conversations about your business, your challenges, and where you want to go.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">2</div>
                                <h4>Assess</h4>
                                <p>We review your current technology, find what's working, what's not, and where there's room to improve.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">3</div>
                                <h4>Recommend</h4>
                                <p>You get a clear plan with specific steps, realistic timelines, and budget estimates — no fluff.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">4</div>
                                <h4>Support</h4>
                                <p>We help you put the plan into action and stay available for the questions that come up along the way.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Why Us + Free Consult */}
            <div className="av-section-v2 av-bg-slate">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 m-b30">
                            <div className="av-panel-accent">
                                <h3>Why businesses come to us</h3>
                                <p>We've been doing this for over 12 years, and our approach hasn't changed — give honest advice, keep it practical, and always put the client's needs first.</p>

                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-users"></i></div>
                                    <div>
                                        <h5>We're independent</h5>
                                        <p>We don't sell software or take commissions. Our recommendations are based on what's best for you, period.</p>
                                    </div>
                                </div>
                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-dollar-sign"></i></div>
                                    <div>
                                        <h5>We respect your budget</h5>
                                        <p>We've helped plenty of businesses find great solutions that didn't break the bank. Expensive doesn't always mean better.</p>
                                    </div>
                                </div>
                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-clock"></i></div>
                                    <div>
                                        <h5>We're here for the long run</h5>
                                        <p>Technology changes fast. We stay in touch and help you adapt as your business grows and your needs evolve.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 m-b30">
                            <div className="av-callout">
                                <h4>Free 30-Minute Consultation</h4>
                                <p>Not sure where to start? Let's have a conversation. No pressure, no sales pitch — just a chance to talk through your challenges and see how we can help.</p>
                                <a href="/contact-us" className="av-callout-btn">
                                    Book Your Call <i className="feather feather-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA */}
            <div className="av-section-v2">
                <div className="container">
                    <div className="av-cta-v2">
                        <h3>Ready to get some clarity on your technology?</h3>
                        <p>Let's talk about what's going on with your business and figure out the smartest path forward together.</p>
                        <div className="av-cta-actions">
                            <a href="/contact-us" className="av-btn-white">Get in Touch</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ITConsultancyPage;
